
import React from "react";
import { cn } from "@/lib/utils";
import { SidebarCoreContent } from "./sidebar/SidebarCoreContent";
import { SidebarToggle } from "./sidebar/SidebarToggle";

interface SidebarProps {
  collapsed: boolean;
  toggleSidebar: () => void; // This is for desktop collapse/expand
}

const Sidebar = ({ collapsed, toggleSidebar }: SidebarProps) => {
  return (
    <aside
      className={cn(
        "sticky top-0 h-screen flex-col p-4 space-y-6 hidden md:flex transition-all duration-300 shadow-xl border-r",
        "border-sidebar-border bg-sidebar backdrop-blur-lg",
        collapsed ? "w-20" : "w-64"
      )}
    >
      {/* SidebarToggle is part of the desktop sidebar structure, not core content */}
      <SidebarToggle collapsed={collapsed} toggleSidebar={toggleSidebar} />
      
      {/* SidebarCoreContent will render SidebarHeader and NavGroups */}
      <SidebarCoreContent collapsed={collapsed} />
      {/* Note: onLinkClick is not needed for desktop sidebar as it doesn't need to close a sheet */}
    </aside>
  );
};

export default Sidebar;
